<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <header class="content__title pl-0">
            <h1>Fertiliser Additives</h1>

            <div class="actions">
                <a class="btn btn-success btn--icon" @click.prevent="showCreateDialog"
                   v-b-tooltip.left title="Add new fertiliser additive"><i class="zmdi zmdi-plus"></i></a>
            </div>
        </header>

        <div class="card">
            <div class="bg-primary align-items-center d-flex">
                <h5 class="card-header text-white">All Fertiliser Additives</h5>
                <b-pagination align="right" class="my-auto mr-2 ml-auto"
                              :total-rows="pagination.total"
                              v-model="pagination.page"
                              :per-page="pagination.limit"
                />
            </div>
            <b-table hover stacked="md" :items="tableData" sort-by="name" :fields="table.fields"
                     :per-page="pagination.limit" :current-page="pagination.page"
                     :show-empty="true">
                <template slot="badges" slot-scope="data">
                    <span class="badge badge-danger" v-if="data.item.deleted_at">
                    Disabled
                    </span>
                </template>
                <template slot="actions" slot-scope="row">

                    <b-button @click="showEditDialog(row.item)"
                              variant="secondary btn--icon"
                              v-b-tooltip.hover="'Edit Fertiliser Additive'">
                        <i class="zmdi zmdi-edit"></i>
                    </b-button>

                </template>
            </b-table>
        </div>
        <CreateModal :close="closeCreateDialog" v-model="creating" v-if="creating" />
        <EditModal :close="closeEditDialog" :fertiliserAdditive="editingFertiliserAdditive" v-model="editingFertiliserAdditive" v-if="editingFertiliserAdditive" />
    </div>
</template>

<script>
import listFertiliserAdditivesQuery from '@views/FertiliserAdditives/Browse/queryListFertiliserAdditives.graphql';
import CreateModal from './CreateModal';
import EditModal from './EditModal';

export default {
  name: 'BrowseFertiliserAdditives',
  apollo: {
    fertiliserAdditives: {
      query: listFertiliserAdditivesQuery,
      variables: { input: { include_deleted: true } },
      manual: true,
      result({ data, loading }) {
        if (!loading) {
          this.fertiliserAdditives = data.filterFertiliserAdditives.data;
          this.pagination.total = data.filterFertiliserAdditives.meta.total;
        }
      },
    },
  },
  data() {
    return {
      fertiliserAdditives: [],
      editingFertiliserAdditive: null,
      creating: false,
      loading: 0,
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
      },
      table: {
        fields: [
          {
            key: 'name',
            label: 'FertiliserAdditive',
            sortable: true,
          },
          {
            key: 'badges',
            label: 'Statuses',
          },
          {
            key: 'actions',
            label: '',
            tdClass: 'text-right',
          },
        ],
      },
    };
  },
  computed: {
    tableData() {
      return this.fertiliserAdditives;
    },
  },
  methods: {
    showEditDialog(additive) {
      this.editingFertiliserAdditive = additive;
    },
    closeEditDialog() {
      this.editingFertiliserAdditive = null;
    },
    showCreateDialog() {
      this.creating = true;
    },
    closeCreateDialog() {
      this.creating = false;
    },
  },
  components: {
    EditModal,
    CreateModal,
  },
};
</script>
